import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NotificationState {
  notificationOnboardingComplete: boolean;
  notificationOnboardingSkipped: boolean;
  registrationToken: string | null;
  registrationError: string | null;
  isRegistered: boolean;
  
  setNotificationOnboardingComplete: (complete: boolean) => void;
  setNotificationOnboardingSkipped: (skipped: boolean) => void;
  setRegistrationToken: (token: string | null) => void;
  setRegistrationError: (error: string | null) => void;
  setIsRegistered: (registered: boolean) => void;
  clearNotificationState: () => void;
}

export const useNotificationStore = create<NotificationState>()(
  persist(
    (set) => ({
      notificationOnboardingComplete: false,
      notificationOnboardingSkipped: false,
      registrationToken: null,
      registrationError: null,
      isRegistered: false,

      setNotificationOnboardingComplete: (complete) => {
        set({ notificationOnboardingComplete: complete });
      },

      setNotificationOnboardingSkipped: (skipped) => {
        set({ notificationOnboardingSkipped: skipped });
      },

      setRegistrationToken: (token) => {
        set({ registrationToken: token });
      },

      setRegistrationError: (error) => {
        set({ registrationError: error });
      },

      setIsRegistered: (registered) => {
        set({ isRegistered: registered });
      },

      clearNotificationState: () => {
        set({
          notificationOnboardingComplete: false,
          notificationOnboardingSkipped: false,
          registrationToken: null,
          registrationError: null,
          isRegistered: false,
        });
      },
    }),
    {
      name: 'notification-storage',
    }
  )
);

